/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Content/view.blocks to change it.
import * as fromData from 'Simple/Data'
import React from 'react'
import TysiaCalendar from 'DesignSystem/TysiaCalendarBlocks/TysiaCalendar/react'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Content({
  children,
  viewPath = "/App/Account/Content/Calendar/New/Content/Content/CollapsibleSidebar/MonthlyCalendar/Content",
  renderDay,
  weekdayElement
  
}) {
let sidebarDateValueData = fromData.useDataValue({ viewPath,
context: 'sidebar',
path: 'date',
})
  return (<React.Fragment
>
<div
  data-testid="Content.Vertical"
  data-view-path={viewPath}
 className={`views-block ${styles.Vertical}`}
>
<TysiaCalendar
  viewPath={`${viewPath}/TysiaCalendar`}
 showWeekendDays={true}
 showNavBar={false}
 renderDay={renderDay}
 weekdayElement={weekdayElement}
 showOutsideDays={true}
 dayPadding="0px"
 data="sidebar.date"
 month={sidebarDateValueData}
/>
</div>
{children}
</React.Fragment>)
}